import AG_GRID_LOCALE_EN from './locale.en'
import { i18n } from '~/plugins/i18n/-i18n'
const AG_GRID_LOCALE_CUSTOM = {}

Object.keys(AG_GRID_LOCALE_EN).forEach(function (key) {
  if (key === 'thousandSeparator' || key === 'decimalSeparator') {
    return
  }

  AG_GRID_LOCALE_CUSTOM[key] = i18n.global.t(`agGrids.${key}`)
})

export default AG_GRID_LOCALE_CUSTOM
